/**
 * Protected Widget Route Component
 *
 * Wrapper component that protects widget routes requiring authentication.
 * Redirects to login page if customer is not authenticated.
 */

import { Navigate, useLocation } from 'react-router-dom';
import { useWidgetAuth } from '../../contexts/WidgetAuthContext';

interface ProtectedWidgetRouteProps {
  children: React.ReactNode;
}

export function ProtectedWidgetRoute({ children }: ProtectedWidgetRouteProps) {
  const { isAuthenticated, isLoading } = useWidgetAuth();
  const location = useLocation();

  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="../login" state={{ from: location }} replace />;
  }

  // Render protected content
  return <>{children}</>;
}
